module.exports = __webpack_public_path__ + "img/bg.65aa2135.jpg";